 
window.addEventListener("load", () => {
  setTimeout(() => {
    const featured_collections = document.querySelectorAll('.featured-swiper');
    const featured_collection_alt = document.querySelectorAll('.featured-swiper-alternate');
    featured_collections.forEach(swiper => {
      const parent = swiper.closest('.featured-collection-section');
      const btn_next = parent.querySelector('.swiper-button-next');
      const btn_prev = parent.querySelector('.swiper-button-prev');
      const featured_swiper = new Swiper(swiper, {
          // Optional parameters
          direction: 'horizontal',
          slidesPerView: 5,
          // simulateTouch: false,
          spaceBetween: 16,
          speed: 300,
          loop: false,
          breakpoints: {
              // when window width is >= 320px
              320: {
                slidesPerView: 2,
                spaceBetween: 16
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 3,
                spaceBetween: 16
              },
              // when window width is >= 1024px
              1024: {
                slidesPerView: 4,
                spaceBetween: 16
              },
              // when window width is >= 1200px
              1200: {
                slidesPerView: 5,
                spaceBetween: 16
              }
          },
        
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
          },
        
          // Navigation arrows
          navigation: {
            // nextEl: '.featured-collection-section  .swiper-button-next',
            // prevEl: '.featured-collection-section  .swiper-button-prev',
            nextEl: btn_next,
            prevEl: btn_prev,
          },
        
          // And if we need scrollbar
          // scrollbar: {
          //   el: '.swiper-scrollbar',
          // },
        });
        // console.log(swiper, featured_swiper);
        
      });
      featured_collection_alt.forEach(swiper => {
        const parent = swiper.closest('.featured-collection-section');
        const btn_next = parent.querySelector('.swiper-button-next');
        const btn_prev = parent.querySelector('.swiper-button-prev');
        const featured_swiper = new Swiper(swiper, {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 5,
            // simulateTouch: false,
            spaceBetween: 16,
            speed: 300,
            loop: false,
            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 1.2,
                  spaceBetween: 16
                },
                // when window width is >= 768px
                768: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 16
                },
                // when window width is >= 1200px
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 16
                }
            },
          
            // If we need pagination
            pagination: {
              el: '.swiper-pagination',
            },
          
            // Navigation arrows
            navigation: {
              // nextEl: '.featured-collection-section  .swiper-button-next',
              // prevEl: '.featured-collection-section  .swiper-button-prev',
              nextEl: btn_next,
              prevEl: btn_prev,
            },
          
            // And if we need scrollbar
            // scrollbar: {
            //   el: '.swiper-scrollbar',
            // },
          });
          // console.log(swiper, featured_swiper);
          
        });
  }, 2000);
});

const testimonialSwipers = document.querySelectorAll('.testimonials-slider');
const testimonialSwipersbox = document.querySelectorAll('.testimonials-slider-box');
const iconsSwipers = document.querySelectorAll('.icons-swiper');
iconsSwipers.forEach(swiper => {
  const iconSwiper = new Swiper(swiper, {
    direction: 'horizontal',
    slidesPerView: 1.5,
    spaceBetween: 16,
    speed: 300,
    loop: false,
    breakpoints: {
        // when window width is >= 320px
        320: {
          enabled: true,
          slidesPerView: 1.9,
          spaceBetween: 16
        },
        // when window width is >= 480px
        480: {
          enabled: true,
          slidesPerView: 1.9,
          spaceBetween: 16
        },
        // when window width is >= 640px
        640: {
          enabled: true,
          slidesPerView: 1.9,
          spaceBetween: 16
        },
        // when window width is >= 768px
        768: {
          enabled: false
        }
        // when window width is >= 1024px
        // 1024: {
        //   slidesPerView: 4,
        //   spaceBetween: 16
        // },
        // when window width is >= 1200px
        // 1200: {
        //   slidesPerView: 5,
        //   spaceBetween: 16
        // }
    },
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.icons-blocks-wrapper .swiper-button-next',
      prevEl: '.icons-blocks-wrapper .swiper-button-prev',
    },
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  })
  // console.log(iconSwiper);
});
var galleryThumbs, galleryTop;
$(function () {
  galleryThumbs = new Swiper(".thumbnails-wrapper", {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.thumbs-nav-wrapper .swiper-button-next',
      prevEl: '.thumbs-nav-wrapper .swiper-button-prev',
    },
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 5
      }
    }
  });
  galleryTop = new Swiper(".main-slider", {
    direction: "horizontal",
    slidesPerView: 1,
    effect: 'fade',
    spaceBetween: 10,
    navigation: {
      nextEl: '.main-slider-nav .swiper-button-next',
      prevEl: '.main-slider-nav .swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
  
  galleryTop.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryTop.activeIndex);
  });
  galleryThumbs.on("transitionStart", function () {
    galleryTop.slideTo(galleryThumbs.activeIndex);
  });
});

const thumbSlider_items = document.querySelectorAll('.thumbnail-slider li.thumbnail-list__item');
const mediaSlider = document.querySelectorAll('.product__media-list li.product__media-item');
thumbSlider_items.forEach(element => {
  element.addEventListener('click', ()=> {
    const target = element.dataset.target;
    const targetMedia = document.querySelector(`.product__media-list li[data-media-id=${target}]`);
    console(targetMedia);
  })
});
testimonialSwipers.forEach(testimonialSwiper => {
  const iconSwiper = new Swiper(testimonialSwiper, {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 300,
    autoplay:{
      delay: 5000
    },
    loop: true,
    navigation: {
      nextEl: '.testimonial-slider-nav .swiper-button-next',
      prevEl: '.testimonial-slider-nav .swiper-button-prev',
    },
    breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        
        // when window width is >= 768px
        1024: {
          slidesPerView: 3,
          spaceBetween: 16
        }
    }
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  })
})
testimonialSwipersbox.forEach(testimonialSwiper => {
  const iconSwiper = new Swiper(testimonialSwiper, {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 300,
    autoplay:{
      delay: 5000
    },
    loop: true,
    navigation: {
      nextEl: '.testimonial-slider-nav .swiper-button-next',
      prevEl: '.testimonial-slider-nav .swiper-button-prev',
    },
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  })
})


var thumbs2 = new Swiper ('.product-images__Slider-nav', {
  slidesPerView: 4,
  spaceBetween: 10,
  centeredSlides: true,
  loop: false,
  slideToClickedSlide: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});
var subscriptionProductSwiper = new Swiper ('.product-images__Slider-main', {
  slidesPerView: 1,
  // centeredSlides: true,
  spaceBetween: 10,
  loop: false,
  // loopedSlides: 6, 
  slideToClickedSlide: true,
  navigation: {
      nextEl: '.swiper-main-nav--wrapper .swiper-button-next1',
      prevEl: '.swiper-main-nav--wrapper .swiper-button-prev1',
  }
});
 
subscriptionProductSwiper.controller.control = thumbs2;
thumbs2.controller.control = subscriptionProductSwiper;

subscriptionProductSwiper.on('slideChange', function (e) { 
    let activeImageAlt = subscriptionProductSwiper.slides[subscriptionProductSwiper.activeIndex].querySelector('img').getAttribute('alt');
    (activeImageAlt) ? document.querySelector('.description-wrapper p').innerHTML = activeImageAlt : ''
    console.log('Active Slide Image URL: ' + activeImageAlt);
});

const upsell_swiper = new Swiper('.upsell-swiper', {
  slidesPerView: 2.3,
  spaceBetween: 15,
  centeredSlides: true,
  speed: 500,
  loopedSlides: 3,
  loop: true,
  navigation: {
    nextEl: '.cart-notification-upsell .swiper-button-next',
    prevEl: '.cart-notification-upsell .swiper-button-prev',
  },
})



var init = false;
var iconsSwiper;
var initIconsSwiper = () => {
  const viewport = window.innerWidth;
  if (viewport < 768) {
    if (!init) {
        iconsSwiper = new Swiper(".icon-swiper-mobile", {
          slidesPerView: 1.8,
          spaceBetween: 16,
          loop: true,
          speed: 700,
          centeredSlides: true,
          simulateTouch: false,
          // autoplay: {
          //   delay: 5000,
          // },
          breakpoints: {
            320: {
              slidesPerView: 1.8,
              spaceBetween: 16
            },
            // when window width is >= 480px
            620: {
              slidesPerView: 3,
              spaceBetween: 16
            },
            750: {
              slidesPerView: 1.2,
              spaceBetween: 16
            },
          },
          navigation: {
            nextEl: '.get-box-text-block .swiper-button-next',
            prevEl: '.get-box-text-block .swiper-button-prev',
          },
      });
    } else if (init) {
      iconsSwiper.destroy();
      init = false;
    }
  }
};
window.addEventListener('resize', initIconsSwiper);
initIconsSwiper();

function getSiblings(e) {
  // for collecting siblings
  let siblings = []; 
  // if no parent, return no sibling
  if(!e.parentNode) {
      return siblings;
  }
  // first child of the parent node
  let sibling  = e.parentNode.firstChild;
  
  // collecting siblings
  while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
          siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
  }
  return siblings;
};


$(".toggle_btn").click(function(){
  $(this).toggleClass("active");
 $(".desc-wrapper").toggleClass("active");

 if($(".toggle_btn").hasClass("active")){
   $(".toggle_text").text("Show Less");
 }
 else{
   $(".toggle_text").text("Show More");
   $("html, body").animate({ scrollTop: 0 }, 600);
 }
});
var collection = document.querySelector('.template--collection');
if (collection) {
  const readmore = document.querySelectorAll('#readmore');
  const readless = document.querySelectorAll('#readless')
  readmore.forEach(btn => {
    btn.addEventListener('click',function (e) {
      e.preventDefault();
      const descEl = btn.closest('.collection-description');
      var descriptionFull = descEl.querySelector('.product-description-full');
      descriptionFull.style.display = 'block';
      var descriptionShort = descEl.querySelector('.product-description-short');
      descriptionShort.style.display = 'none';
    });
  })
  readless.forEach(btn => {
    btn.addEventListener('click',function (e) {
      e.preventDefault();
      const descEl = btn.closest('.collection-description');
      var descriptionFull = descEl.querySelector('.product-description-full');
      descriptionFull.style.display = 'none';
      var descriptionShort = descEl.querySelector('.product-description-short');
      descriptionShort.style.display = 'block';
      $("html, body").animate({ scrollTop: 0 }, 600);
    }); 
  })

  var btn = $('#back-top-btn');

  $(window).scroll(function() {
    var bodyRect = document.body.getBoundingClientRect(),
    faqsRect = document.querySelector('.collection-faqs').getBoundingClientRect(),
    offset  = (faqsRect.top - bodyRect.top) - 300;
    if ($(window).scrollTop() >= offset) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });
}
// const productJson = document.querySelector('[data-product-json]').textContent;
const subscriptionInputs = document.querySelectorAll('input[name="subscription-product-selector"]');
const subscriptionATC = document.querySelector('#subscriptionATC');
const priceDiv = document.querySelector('.price-wrapper');
let subscription_ATC ;
console.log(subscriptionInputs,"Hassan Abbas");
subscriptionInputs.forEach(input => {
  input.addEventListener('change', () => {
    const form = input.closest('form');
    const variant_input = form.querySelector('[name="id"]');
    const varientID = input.dataset.variantId;
    variant_input.value = varientID;
    const selected_price_wrapper = priceDiv.querySelector(`.price-wrapper [data-product-id="${varientID}"]`);
     subscription_ATC = document.querySelector('.price-CTA-wrapper');
    // console.log(selected_price_wrapper);
    const siblings = getSiblings(selected_price_wrapper);
    siblings.forEach(sibling => sibling.classList.add('hidden'));
    selected_price_wrapper.classList.remove('hidden');
    subscriptionATC.setAttribute('data-product-id', varientID);
    localStorage.setItem('aikey', subscription_ATC.outerHTML);
    document.querySelector('.ai-section').innerHTML = localStorage.getItem('aikey');
  })
});

if(localStorage.getItem('aikey')){
  document.querySelector('.ai-section').innerHTML = localStorage.getItem('aikey');
  document.querySelector('.ai-section').firstElementChild.classList.add('sticky');
}
else{
  document.querySelector('#ai-subscription-cta button').addEventListener('click',(e)=>{
    localStorage.setItem('aikey', "");
})
}

// subscriptionATC.addEventListener('click', (e) => {
//   // console.log(subscriptionATC.dataset.productId);
//   var data = {
//       items: [{
//         id: subscriptionATC.dataset.productId,
//         properties: {
//           shipping_interval_unit_type: "Months",
//           shipping_interval_frequency: 1
//         },
//         quantity: 1
//       }]
//     };
//     ShopifyATC(data);
// })





ShopifyATC = (addData) => {

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    location.href = "/cart";
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
}
subscription_ATC = document.querySelector('.price-CTA-wrapper');
if (subscription_ATC) {
  const viewport = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
  //if(subscriptionATC.offsetTop != null){
   //const divOffset = (subscriptionATC.offsetTop) - subscriptionATC.offsetHeight - 160;  
  //}
  if (viewport < 768 ) {
    window.addEventListener('scroll', function(){
      const getScrollPosition = (el = window) => ({
        x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
        y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
      });
      
      
      const viewTop = getScrollPosition().y;
      //console.log(viewTop, divOffset);
        // console.log(subscription_ATC);
        subscription_ATC.classList.add('sticky');
      
      
    })
  }
}

